import React from 'react';
import './StatusPages.css';
import Footer from './Footer';
import HomeButton from './HomeButton';

const Offline = () => {
  return (
    <div className="status-page">
        <HomeButton/>
      <div className="status-container">
        <div className="offline-icon">
          <i className="fas fa-wifi-slash"></i>
        </div>
        <div className="status-card">
          <h2>Signal Lost</h2>
          <p>You are currently offline. Please check your connection to resume your session with OZIA.</p>
          <button className="status-btn" onClick={() => window.location.reload()}>
            Retry Connection
          </button>
        </div>
      </div>
                  <div className="footer-wrapper">
                  <Footer />
              </div>
    </div>
  );
};

export default Offline;